import { apiAgent } from "../../config/axiosConfig";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  updateLoadError,
  setLoadingState,
  setSavingState,
} from "./variableSlice";

export const createVariable = createAsyncThunk(
  "createVariable",
  async (
    { resourceId, resourceType, var_name, var_value },
    { dispatch, rejectWithValue }
  ) => {
    await dispatch(setLoadingState(true));
    try {
      const response = await apiAgent({
        method: "POST",
        url: "/api/v1/variables",
        data: {
          var_name,
          var_value,
          resource_type: resourceType,
          resource_id: resourceId,
        },
      });
      if (response.status === 200) {
        // await dispatch(setSelectedTestScenario({testScenarioId: response?.data?.id}))
        await dispatch(setLoadingState(false));
        return response?.data;
      } else {
        await dispatch(setLoadingState(false));
        return rejectWithValue(response.data);
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
    }
  }
);

export const updateVariable = createAsyncThunk(
  "updateVariable",
  async ({ variableValue, variableId }, { dispatch, rejectWithValue }) => {
    await dispatch(setSavingState(true));
    try {
      const response = await apiAgent({
        method: "PUT",
        url: `/api/v1/variables/${variableId}`,
        data: {
          var_value: variableValue,
        },
      });
      if (response.status === 200) {
        await dispatch(setSavingState(false));
        return response?.data;
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
    }
  }
);

export const updateVariableByKey = createAsyncThunk(
  "updateVariableByKey",
  async ({ varName, varValue, resourceType, resourceId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiAgent({
        method: "PUT",
        url: `/api/v1/variables/update_by_key`,
        data: {
          var_name: varName,
          var_value: varValue,
          resource_type: resourceType,
          resource_id: resourceId
        },
      });
      if (response.status === 200) {
        return response?.data;
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
    }
  }
);

export const replaceValuesWithVarName = createAsyncThunk(
  "replaceValuesWithVarName",
  async ({ variableId }, { dispatch, rejectWithValue }) => {
    await dispatch(setSavingState(true));
    try {
      const response = await apiAgent({
        method: "POST",
        url: `/api/v1/variables/${variableId}/replace_values_with_var_name`,
      });
      if (response.status === 200) {
        await dispatch(setSavingState(false));
        return response?.data;
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
    }
  }
);

export const deleteVariable = createAsyncThunk(
  "deleteVariable",
  async ({ variableId }, { dispatch, rejectWithValue }) => {
    await dispatch(setSavingState(true));
    try {
      const response = await apiAgent({
        method: "DELETE",
        url: `/api/v1/variables/${variableId}`,
      });
      if (response.status === 200) {
        await dispatch(setSavingState(false));
        return response?.data;
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
    }
  }
);

export const getVariable = createAsyncThunk(
  "getVariable",
  async ({ variableId }, { dispatch, rejectWithValue }) => {
    await dispatch(setLoadingState(true));
    try {
      const response = await apiAgent({
        method: "GET",
        url: `/api/v1/variables/${variableId}`,
      });
      if (response.status === 200) {
        await dispatch(setLoadingState(false));
        return response?.data;
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
      await dispatch(setLoadingState(false));
    }
  }
);

export const getAllVariables = createAsyncThunk(
  "getAllVariables",
  async ({ resourceId }, { dispatch, rejectWithValue }) => {
    await dispatch(setLoadingState(true));
    try {
      const response = await apiAgent({
        method: "GET",
        url: `/api/v1/variables/?resource_id=${resourceId}`,
      });
      if (response.status === 200) {
        await dispatch(setLoadingState(false));
        return response?.data?.variables;
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
      await dispatch(setLoadingState(false));
    }
  }
);

export const bulkCreateVariables = createAsyncThunk(
  "variables/bulkCreate",
  async (variables, { dispatch, rejectWithValue }) => {
    try {
      const res = await apiAgent({
        method: "post",
        url: "/api/v1/variables/bulk_create",
        data: {
          variables: variables,
        },
      });
      if (res.status === 200) {
        return res.data.variables;
      } else {
        return rejectWithValue(res.data);
      }
    } catch (err) {
      dispatch(
        updateLoadError({
          error_message:
            err.response?.data?.message || "Unknown error occurred",
        })
      );
      return rejectWithValue(err);
    }
  }
);

export const bulkUpdateVariables = createAsyncThunk(
  "variables/bulkUpdate",
  async (variables, { dispatch, rejectWithValue }) => {
    try {
      const res = await apiAgent({
        method: "patch",
        url: "/api/v1/variables/bulk_update",
        data: {
          variables: variables,
          ids: variables.map((variable) => variable.id),
        },
      });
      if (res.status === 200) {
        return res.data.variables;
      } else {
        return rejectWithValue(res.data);
      }
    } catch (err) {
      dispatch(
        updateLoadError({
          error_message:
            err.response?.data?.message || "Unknown error occurred",
        })
      );
      return rejectWithValue(err);
    }
  }
);
